module.exports = __webpack_public_path__ + "img/logo2.95023898.png";